import { render } from "./Footer.vue?vue&type=template&id=2dac9b4c"
const script = {}

import exportComponent from "/Users/virusandy/Work/personal/voixware/speech2subs.com/v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__